// El access_code de un pedido es: AA (2 dígitos de año) + secuencia con ceros a la izquierda.
//   2600908  → 2026 + 000908 → "LB 2026-908"
//   17002698 → 2017 + 002698 → "LB 2017-2698"
// (Antes se hacía replace(/0/g,"") y borraba TODOS los ceros → "2600908" quedaba "2698", ilegible.)
export const formatLbOrderCode = (rawCode) => {
  const original = typeof rawCode === "string" || typeof rawCode === "number"
    ? String(rawCode).trim()
    : "";

  if (!original) return "";

  const digits = original.replace(/\D/g, "");

  // No parece un access_code numérico (p.ej. username de nombre) → devolver tal cual.
  if (digits.length < 3) {
    return original;
  }

  const year = 2000 + parseInt(digits.slice(0, 2), 10);
  const seq = digits.slice(2).replace(/^0+/, "") || "0";

  return `LB ${year}-${seq}`;
};
